<template>
  <OrderItemApplyAllPopover ref="applyPopover" headerTitle="Apply Discount" :itemList="validItemList" @applySettings="applySettings">

    <FormInputText type="number" ref="discountRateEntry" v-model="discountRate" placeholder="Discount" addon="%" />

    <div class="m-2" />

  </OrderItemApplyAllPopover>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import OrderItemApplyAllPopover from '@/modules/orders/components/orderItemApplyAllPopover.vue'

import { InventoryStockTypes, UOMTypes } from '@/store/types'

export default {
  name: 'OrderItemApplyAllDiscountPopover',
  mixins: [form],
  components: {
    OrderItemApplyAllPopover
  },
  props: {
    itemList: Array
  },
  computed: {
  },
  data() {
    return {
      discountRate: 0,
      validItemList: []
    }
  },
  methods: {
    displayFromElement(element) {
      this.discountRate = 0

      this.validItemList = this.itemList
      .filter(item => item.stockId != null)
      .map(item => {
        var name = `${item.stock.code} - ${item.stock.name}`
        let parentItem = this.itemList.find(parentItem => parentItem.id == item.parentOrderItemId)
        if(parentItem)
          name = `${parentItem.stock.code}<i class="fas fa-caret-right mx-2"></i>${name}`

        if(item.stockType == InventoryStockTypes.glass)
          name += ` - ${item.glassHeight}x${item.glassWidth}`

        return {
          id: item.id,
          name: name
        }
      })

      this.$refs.applyPopover.displayFromElement(element)

      this.$nextTick(() => {
        this.$refs.discountRateEntry.select()
        this.$refs.discountRateEntry.focus()
      })
    },
    
    applySettings(itemList) {

      this.$emit('applyDiscount', {
        discountRate: parseFloat(this.discountRate),
        itemList: itemList
      })
    }
    
  }
}
</script>